/**
 * @generated SignedSource<<f784264453711c262c7e5a1e51644a08>>
 * @relayHash 7afcbc16176f32c351c7b4d37a8db3cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5e19a480b4a1bad799e460756eb2ff7e6ca8390a94f5ad42533c615a9367035f

import type { ConcreteRequest } from 'relay-runtime';
export type useSpaceIconSpaceIconQuery$variables = {
  spaceKey: string;
};
export type useSpaceIconSpaceIconQuery$data = {
  readonly space: {
    readonly homepage: {
      readonly id: string | null | undefined;
    } | null | undefined;
    readonly icon: {
      readonly path: string;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useSpaceIconSpaceIconQuery = {
  response: useSpaceIconSpaceIconQuery$data;
  variables: useSpaceIconSpaceIconQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "path"
          }
        ]
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpaceIconSpaceIconQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpaceIconSpaceIconQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7afcbc16176f32c351c7b4d37a8db3cb",
    "id": "5e19a480b4a1bad799e460756eb2ff7e6ca8390a94f5ad42533c615a9367035f",
    "metadata": {},
    "name": "useSpaceIconSpaceIconQuery",
    "operationKind": "query",
    "text": "query useSpaceIconSpaceIconQuery($spaceKey:String!){space(key:$spaceKey){id,icon{path},homepage{id}}}"
  }
};
})();

(node as any).hash = "3d2bab97a5f5ad529c57f87fecaeb1f2";

export default node;
